export default {
  path: '/2019HealthAnniversary',
  name: '2019HealthAnniversary',
  component: () => import('./Home.vue'),
  meta: {
    title: '我和我的祖国 重庆卫生健康70年70秒微视频大赛优秀作品展播',
  },
  redirect: '/2019HealthAnniversary/homeIndex',
  children: [
    {
      path: 'homeIndex',
      name: 'homeIndex',
      component: () => import('./HomeIndex.vue'),
      meta: {
        title: '我和我的祖国 重庆卫生健康70年70秒微视频大赛优秀作品展播',
      },
    },
    {
      path: 'detailPage',
      component: () => import('./DetailPage.vue'),
      meta: {
        title: '我和我的祖国 重庆卫生健康70年70秒微视频大赛优秀作品展播',
      },
    },
  ],
};
